import React from 'react';
import PropTypes from 'prop-types';

function ModuleContainer(props) {
	const {
		children,
		title,
		headerLink,
		hideHeaderBorder,
		moduleHeaderContent,
		className,
		titleTag: Tag
	} = props;

	return (
		<div className={`module-wrapper ${className}`}>
			<div className={`module-header ${hideHeaderBorder ? '' : 'with-border'}`}>
				<div className="header-content clearfix">
					{title && <Tag className="float-left h5 title">{title}</Tag>}
					{moduleHeaderContent}
					<span className="header-link float-right">{headerLink}</span>
				</div>
			</div>
			<div className="module-body">
				{children}
			</div>
		</div>
	);
}

/**
 * Helpful info for adding prop types
 * https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
 */
ModuleContainer.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(
			PropTypes.oneOfType([
				PropTypes.element,
				PropTypes.arrayOf(
					PropTypes.element
				)])
		)
	]),
	moduleHeaderContent: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element)
	]),
	title: PropTypes.string,
	headerLink: PropTypes.element,
	hideHeaderBorder: PropTypes.bool,
	className: PropTypes.string,
	titleTag: PropTypes.string
};

ModuleContainer.defaultProps = {
	className: '',
	moduleHeaderContent: null,
	children: null,
	title: null,
	hideHeaderBorder: false,
	headerLink: null,
	titleTag: 'h3'
};

export default ModuleContainer;
